import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, retry, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar'; // Import MatSnackBar

@Injectable({
  providedIn: 'root'
})
export class ApiSentrynelService {
  private baseUrl: string = environment.apiSentrynelUrl;
  private httpOptions: {
    body?: any;
    headers: {
      [header: string]: string | string[];
    };
    context?: HttpContext;
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
    reportProgress?: boolean;
    responseType: 'json';
    withCredentials?: boolean;
  } = {
    headers: {'Content-Type': 'application/json'},
    responseType: 'json'
  };

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar, // Inject MatSnackBar here
  ) {}

  public get<T>(url: string, retryCount: number = 0): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/${url}`, this.httpOptions).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error))
    );
  }

  public post<T>(url: string, data: any, retryCount: number = 0): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}/${url}`, data, this.httpOptions).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error))
    );
  }

  public put<T>(url: string, data: any, retryCount: number = 0): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}/${url}`, data, this.httpOptions).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error))
    );
  }

  public delete<T>(url: string, retryCount: number = 0): Observable<T> {
    return this.http.delete<T>(`${this.baseUrl}/${url}`, this.httpOptions).pipe(
      retry(retryCount),
      catchError(error => this.handleError(error))
    );
  }

  public setHeader(key: string, value: string | undefined) {
    if (value) {
      if (this.httpOptions.headers) {
        this.httpOptions.headers[key] = value;
      } else {
        this.httpOptions.headers = {
          key: value
        };
      }
    } else {
      delete this.httpOptions.headers[key];
    }
  }

  private handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else if (error.error.listaErrori) {
      // Get server-side error
      error.error.listaErrori.forEach((errorItem: { codiceErrore: string, descrizioneErrore: string }) => {
        this.snackBar.open(`Errore: ${errorItem.descrizioneErrore}`, 'close', {
          duration: 3000, // Optional: Set duration for snack bar
        });
      });
    } else if (error.error.codiceErrore) {
      this.snackBar.open(`Errore: ${error.error.descrizioneErrore}`, 'close', {
        duration: 3000,
      });
    } else if (error.error.error) {
      this.snackBar.open(`Errore: Mi dispiace, qualcosa non va. <br>(${error.error.status} - ${error.error.error})`, 'close', {
        duration: 3000,
      });
    } else {
      this.snackBar.open(`Errore: Mi dispiace, il server non risponde.`, 'close', {
        duration: 3000,
      });
    }

    return throwError(() => {
      return errorMessage;
    });
  }
}
